import { keyframes } from 'styled-components';
import { SDS_MOTION_EASING_EXIT, SDS_MOTION_EASING_ENTRY } from '@s-group/design-system-tokens/web/tokens/motion.es6.js';
import { ANGLE_0, ANGLE_90, ANGLE_180, ANGLE_270, ANGLE_360 } from '../IndicatorBase/constants.js';
import { strokeDasharray, arc } from '../IndicatorBase/util.js';

// Keyframes are defined using keyframes function instead of tagged template
// literals, because Prettier fails to format their content properly:
// https://github.com/prettier/prettier/issues/11196
const entryTail = () => keyframes({
    // Start with an empty canvas
    '0%': {
        strokeDasharray: strokeDasharray(ANGLE_0),
        strokeDashoffset: -arc(ANGLE_270),
    },
    // Reveal tail stroke, increase length to a quarter
    '50%': {
        strokeDasharray: strokeDasharray(ANGLE_90),
        strokeDashoffset: -arc(ANGLE_270),
    },
    // Keep tail stroke visible while entryRotate animation is running
    '100%': {
        strokeDasharray: strokeDasharray(ANGLE_90),
        strokeDashoffset: -arc(ANGLE_270),
    },
});
const entryRotate = keyframes({
    // Start with the default orientation
    '0%': {
        opacity: 1,
        transform: 'rotate(0deg)',
    },
    // Wait until entry-tail animation has revealed the stroke
    '50%': {
        opacity: 1,
        transform: 'rotate(0deg)',
    },
    // Rotate the whole SVG image 180 degrees clockwise.
    // This is the starting point of loop-rotate animation.
    '100%': {
        opacity: 1,
        transform: 'rotate(180deg)',
    },
});
const loopRotate = keyframes({
    '0%': {
        opacity: 1,
        transform: 'rotate(-180deg)',
    },
    '100%': {
        opacity: 1,
        transform: 'rotate(180deg)',
    },
});
const loopStrokeHead = () => keyframes({
    // Head is intially hidden, tail is visible
    '0%': {
        strokeDasharray: strokeDasharray(ANGLE_0),
        strokeDashoffset: arc(ANGLE_0),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_EXIT})`,
    },
    // Grow the head while tail is shrinking
    '25%': {
        strokeDasharray: strokeDasharray(ANGLE_180),
        strokeDashoffset: -arc(ANGLE_0),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_ENTRY})`,
    },
    // Head is at the maximum length, tail is hidden
    '50%': {
        strokeDasharray: strokeDasharray(ANGLE_270),
        strokeDashoffset: -arc(ANGLE_0),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_EXIT})`,
    },
    // Shrink the head while tail remains hidden. To keep the head moving
    // forward (clockwise) while its length is shrinking stroke-dashoffset
    // is used to compensate the change. In other words, it ensures that
    // the shrinking happens from the rear end.
    '75%': {
        strokeDasharray: strokeDasharray(ANGLE_180),
        strokeDashoffset: -arc(ANGLE_180),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_ENTRY})`,
    },
    // Head is at the minimum length. Its position is overlapping with
    // the tail that is currently hidden. This allows us to make the tail
    // visible again at the start of the next round and hide the head.
    '100%': {
        strokeDasharray: strokeDasharray(ANGLE_90),
        strokeDashoffset: -arc(ANGLE_270),
        animationTimingFunction: `cubic-bezier(${SDS_MOTION_EASING_EXIT})`,
    },
});
const loopStrokeTail = () => keyframes({
    '0%': {
        strokeDasharray: strokeDasharray(ANGLE_90),
        strokeDashoffset: -arc(ANGLE_270),
        opacity: 1,
    },
    '50%': {
        strokeDasharray: strokeDasharray(ANGLE_0),
        strokeDashoffset: -arc(ANGLE_360),
        opacity: 1,
    },
    '51%': { opacity: 0 },
    '100%': { opacity: 0 },
});

export { entryRotate, entryTail, loopRotate, loopStrokeHead, loopStrokeTail };
//# sourceMappingURL=circle.keyframes.js.map
